import React from 'react';
import PropTypes from 'prop-types';
import { Title, Dot, InternalGrid, Box } from '@paygreen/paygreen-ui';
import { IsMobile, IsDesktop } from '../../utils/tools';

/**
 * @description this component is based on Title component from PG-UI and will be rendered as `<h1>`
 */
const H1Title = ({ title, children, marginBottom, infoIcon, ...rest }) => {
    const TitleWithInfoIcon = () => (
        <InternalGrid
            displayType="grid"
            gridTemplateColumns="auto auto"
            gridGap="sm"
            hasStaticWidth={false}
            alignItems={IsDesktop() ? 'flex-start' : 'center'}
        >
            <Title
                htmlTag="h1"
                textSize="lg"
                colorWab="grey30"
                marginBottom={marginBottom}
                {...rest}
            >
                {title}
            </Title>

            {infoIcon}
        </InternalGrid>
    );

    return (
        <>
            {children ? (
                <InternalGrid
                    displayType={IsMobile() ? 'grid' : 'flex'}
                    flexWrap="wrap"
                    alignItems={!IsDesktop() ? 'baseline' : 'center'}
                    justifyItems="start"
                    justifyContent="flex-start"
                    hasStaticWidth={false}
                >
                    <TitleWithInfoIcon />

                    {!IsMobile() && (
                        <Dot
                            dotStyle="dash"
                            colorPallet="wab"
                            colorWab="grey10"
                            marginBottom="md"
                            marginRight="md"
                            marginLeft="md"
                            style={{ transform: 'rotate(90deg)' }}
                        />
                    )}

                    <Box marginBottom="sm" id="toggleInside">
                        {children}
                    </Box>
                </InternalGrid>
            ) : (
                <TitleWithInfoIcon />
            )}
        </>
    );
};

H1Title.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    marginBottom: PropTypes.string,
};

H1Title.defaultProps = {
    marginBottom: 'xs',
};

export default H1Title;
